import type SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { action } from 'satcheljs';
import type { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/*
 * Action called to switch to to the readWrite recipient well
 */
export let switchToReadWriteRecipientWell = action(
    'switchToReadWriteRecipientWell',
    (formId: string) => ({
        formId: formId,
    })
);

/**
 * Action called to update the current Side Pane ID
 */
export let updateSidePaneType = action(
    'updateSidePaneType',
    (formId: string, newSidePaneType: SidePaneType) => ({
        formId: formId,
        newSidePaneType: newSidePaneType,
    })
);

/**
 * Action to show/hide scheduling assistant.
 */
export let setShowSchedulingAssistant = action(
    'setShowSchedulingAssistant',
    (formId: string, showSchedulingAssistant: boolean) => ({
        formId: formId,
        showSchedulingAssistant: showSchedulingAssistant,
    })
);

/**
 * Action to set view type of full compose form.
 */
export let setViewType = action(
    'setViewType',
    (formId: string, viewType: FullComposeFormViewType) => ({
        formId: formId,
        viewType: viewType,
    })
);

/**
 * Action to show/hide the date selector time zone controls
 */
export let toggleShowDateSelectorTimeZones = action(
    'toggleShowDateSelectorTimeZones',
    (formId: string, targetWindow: Window) => ({
        formId: formId,
        targetWindow: targetWindow,
    })
);

/**
 * Action to directly set the show/hide state of the date selector time zone controls
 */
export let setShowDateSelectorTimeZones = action(
    'setShowDateSelectorTimeZones',
    (showTimeZones: boolean, formId: string) => ({
        showTimeZones: showTimeZones,
        formId: formId,
    })
);

/**
 * Action to set awaitingServiceResponse flag in the full compose
 */
export let setAwaitingServiceResponse = action(
    'setAwaitingServiceResponse',
    (awaitingServiceResponse: boolean, formId: string) => ({
        awaitingServiceResponse: awaitingServiceResponse,
        formId: formId,
    })
);

/**
 * Action to set isCompactRecipientWellExpanded flag
 */
export let setIsCompactRecipientWellExpanded = action(
    'setCompactRecipientWellExpanded',
    (isCompactRecipientWellExpanded: boolean, formId: string) => ({
        isCompactRecipientWellExpanded: isCompactRecipientWellExpanded,
        formId: formId,
    })
);
